import { render } from "./multicolumnAccount.vue?vue&type=template&id=4f3e3966&scoped=true"
import script from "./multicolumnAccount.vue?vue&type=script&lang=js"
export * from "./multicolumnAccount.vue?vue&type=script&lang=js"

import "./multicolumnAccount.vue?vue&type=style&index=0&id=4f3e3966&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f3e3966"]])

export default __exports__